import {SwivuStoreArchiveMixin} from "./mixins/SwivuStoreArchiveMixin.jsx";
import {Store} from "@bryntum/schedulerpro";

export class EntityContactStore extends SwivuStoreArchiveMixin(Store) {
  static get $name() {
    return "EntityContactStore"
  }

  construct(...args) {
    super.construct(...args);
    // State is not being applied to entity contacts store because we are using data relations approach rather than chained/master store instance
    // Therefore, manually applying the archive filter in construct
    this.swivuArchiveStateChange();
  }

  onChange({ action, records }) {
    if (["add", "remove"].includes(action)) {
      const isAdded = action === "add";
      records.forEach((record) => {
        if (record.resourceRecord) {
          record.resourceRecord.set("hasContacts", isAdded)
        } else if  (record.taskRecord) {
          record.taskRecord.set("hasContacts", isAdded)
        } else if (record.clientRecord) {
          record.clientRecord.set("hasContacts", isAdded)
        } else if (record.userRecord) {
          record.userRecord.set("hasContacts", isAdded)
        }
      })
    }
  }
}